import React from "react";
import logger from '../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logger.error("🔴 Erreur interceptée par ErrorBoundary :", error, info);
    // Tu peux ici loguer vers Sentry ou autre outil
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
          <h2>Une erreur est survenue. Veuillez recharger la page.</h2>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
